import { getDateTimeString } from "../util";

export const columns = [
  {
    title: 'Sucursal Origen',
    sorter: true,
    dataIndex: 'sourceBranch',
    key: 'sourceBranch',
    render: (sourceBranch) => sourceBranch?.name || '-',
  },
  {
    title: 'Sucursal Afectada',
    sorter: true,
    dataIndex: 'affectedBranch',
    key: 'affectedBranch',
    render: (affectedBranch) => affectedBranch?.name || '-',
  },
  {
    title: 'Usuario',
    sorter: true,
    dataIndex: 'user',
    key: 'user',
    render: (_, record) => {
      if (!record.user) {
        return 'Borrado por el sistema';
      }

      return (
        <>
          {record.user.name} {record.user.lastName}{' '}
          {record.user.motherLastName}
        </>
      );
    },
  },
  {
    title: 'Fecha',
    sorter: true,
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => getDateTimeString(date),
  },
];